module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/new-baby-sitting-bg-dd2c45b54f92b96feb6b362cab387471.svg";